"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const CustomModal_1 = __importDefault(require("./CustomModal"));
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const Toast_1 = require("../Toast/Toast");
const core_1 = require("@material-ui/core");
const components_1 = require("@alcumus/components");
const useStyles = (0, core_1.makeStyles)(() => ({
    moveRight: {
        marginLeft: '10px',
    },
    checkboxModify: {
        margin: '4px 10px 0 !important',
        transform: 'scale(1.35)',
    },
    divText: {
        fontWeight: 'normal',
        color: components_1.StyleVariables.colors.black,
    },
}));
const DestructiveModal = ({ formSubmitCallback, successCallback, successMessage, failureMessage, errorMessage, headerText, primaryButtonText, t, visible, setVisible, folderCount, dashboardCount, lookCount, loading = false, }) => {
    const [isFormSubmitting, setIsFormSubmitting] = (0, react_1.useState)(false);
    const isMounted = (0, react_1.useRef)(true);
    const [toastProps, setToastProps] = (0, recoil_1.useRecoilState)(Toast_1.showToastState);
    const [hasAcknowledged, setHasAcknowledged] = (0, react_1.useState)(false);
    const classes = useStyles();
    const handleFormSubmit = async () => {
        formSubmitCallback()
            .then((result) => {
            resetModal();
            if (successCallback)
                successCallback(result);
            return result
                ? setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'success',
                    message: successMessage,
                })
                : setToastProps({
                    ...toastProps,
                    showToast: true,
                    severity: 'error',
                    message: failureMessage,
                });
        })
            .catch((err) => {
            console.error(err);
            setToastProps({
                ...toastProps,
                showToast: true,
                severity: 'error',
                message: errorMessage ?? t('genericErrorMessage', { ns: 'ModalWindow' }),
            });
        })
            .finally(() => {
            if (isMounted.current)
                setIsFormSubmitting(false);
        });
    };
    function resetModal() {
        if (isFormSubmitting)
            return;
        setHasAcknowledged(false);
        setVisible(false);
    }
    const handleCheck = () => {
        hasAcknowledged ? setHasAcknowledged(false) : setHasAcknowledged(true);
    };
    (0, react_1.useEffect)(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    });
    return loading ? (react_1.default.createElement(CustomModal_1.default, { open: visible, headerText: "", danger: true, primaryButtonText: primaryButtonText, disablePrimaryButton: true, onHide: resetModal, isValidating: isFormSubmitting, onPrimaryAction: async () => await handleFormSubmit(), modalBody: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Skeleton, { width: "20%", "data-testid": "SkeletonLoading" }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(material_1.Skeleton, { width: "10%" }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(material_1.Skeleton, { width: "100%" })) })) : (react_1.default.createElement(CustomModal_1.default, { open: visible, headerText: headerText, danger: true, primaryButtonText: primaryButtonText, disablePrimaryButton: !hasAcknowledged, onHide: resetModal, isValidating: isFormSubmitting, onPrimaryAction: async () => await handleFormSubmit(), modalBody: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classes.divText },
                react_1.default.createElement("div", null, t('folderDeleteMessage', { ns: 'ModalWindow' })),
                react_1.default.createElement("br", null),
                react_1.default.createElement("div", null, t('folderDeleteMessage2', { ns: 'ModalWindow' })),
                react_1.default.createElement("br", null),
                react_1.default.createElement("ul", null,
                    react_1.default.createElement("li", null,
                        folderCount,
                        ' ',
                        t('folderDeleteFolderCount', { ns: 'ModalWindow' })),
                    react_1.default.createElement("li", null,
                        dashboardCount,
                        ' ',
                        t('folderDeleteDashboardCount', { ns: 'ModalWindow' })),
                    react_1.default.createElement("li", null,
                        lookCount,
                        " ",
                        t('folderDeleteLookCount', { ns: 'ModalWindow' }))),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("div", { className: classes.moveRight },
                    react_1.default.createElement("input", { type: "checkbox", required: true, onChange: handleCheck, className: classes.checkboxModify, "data-testid": "acknCheckbox", "aria-label": t('deleteAcknowledge', { ns: 'AriaLabels' }) }),
                    t('folderDeleteAcknowledge', { ns: 'ModalWindow' })))) }));
};
exports.default = (0, react_i18next_1.withTranslation)(['ModalWindow', 'AriaLabels'])(DestructiveModal);
